import React from 'react'
import { zip } from 'three/examples/jsm/libs/fflate.module.js'

const FWARibbon = () => {
    const divStyle = {
        position: 'fixed',
        bottom: 0,
        right: 0,
        width: '120px',
        height: '120px',
        zIndex: 998
    }

    const imgStyle = {
        width: '100%',
        height: '100%',
        objectFit: 'contain'
    }

    return (
        <div className='fwa-ribbon'
            style={divStyle}>
            <a href="https://thefwa.com/cases/hnine-interaction-department-brand-site" target="_blank" rel="noopener noreferrer">
                <img src='./data/img/FOTD.png' alt="FWARibbon" style={imgStyle} />
            </a>
        </div>
    )
}

export default FWARibbon